export * from './lib/legal.module';
export * from './lib/components';
export * from './lib/views';
